import type { EnumType } from "~/kernel/enums/EnumType";

export const SubscriptionInvoiceStatus = Object.freeze({
  Draft: "draft",
  Cancelled: "cancelled",
  Sent: "sent",
  Created: "created",
  PaymentProcessing: "paymentProcessing",
  PaymentFailed: "paymentFailed",
  Paid: "paid",
});

export type SubscriptionInvoiceStatus = EnumType<
  typeof SubscriptionInvoiceStatus
>;
